import { Icon } from '@/shared/ui/Icon';
import { Tooltip } from '@/shared/ui/Tooltip';

import styles from './CardHeader.module.css';

type CardHeaderProps = {
  title: string;
  tooltipDescription?: string;
  rightContent?: React.ReactNode;
};

export const CardHeader = ({ title, tooltipDescription, rightContent }: CardHeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleWrapper}>
        <h3 className={styles.title}>{title}</h3>
        {tooltipDescription && (
          <Tooltip title={tooltipDescription} placement="bottom">
            <Icon name="tooltip" />
          </Tooltip>
        )}
      </div>
      <div className={styles.rightCont}>{rightContent}</div>
    </div>
  );
};
